/**
 * BF2 senast visade produkter (klientstyrt, localStorage).
 *
 * Sektion: sections/bf2-recently-viewed.liquid
 *
 * Sparar den aktuella produkten (från JSON-taggen i sektionen) i localStorage,
 * senast först, deduplicerat på handle, max 10 poster. Fyller sedan rutnätet
 * med bf2-produktkort för alla utom den produkt man just nu tittar på. Har
 * sektionen inga tidigare visade produkter att visa hålls den dold.
 */

import { createDebugger } from '~/scripts/utils/debug.js';

const debug = createDebugger('bf2-recently-viewed', false);

const STORAGE_KEY = 'bf2:recently-viewed';
const MAX_ENTRIES = 10;

function readList() {
    try {
        const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
}

function writeList(list) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
        debug.warn('kunde inte spara senast visade', e);
    }
}

// Lägg aktuell produkt överst, dedup på handle, kapa till MAX_ENTRIES.
function record(current) {
    if (!current || !current.handle) return readList();
    const rest = readList().filter((item) => item && item.handle !== current.handle);
    const next = [current, ...rest].slice(0, MAX_ENTRIES);
    writeList(next);
    return next;
}

function el(tag, attrs = {}, children = []) {
    const node = document.createElement(tag);
    for (const [k, v] of Object.entries(attrs)) {
        if (v == null) continue;
        if (k === 'class') node.className = v;
        else node.setAttribute(k, v);
    }
    for (const child of [].concat(children)) {
        if (child == null) continue;
        node.appendChild(typeof child === 'string' ? document.createTextNode(child) : child);
    }
    return node;
}

// Bygg ett bf2-produktkort som matchar snippets/bf2-product-card.liquid.
function card(item) {
    const link = el('a', { class: 'bf2-product group', href: item.url || '#' });

    const imgWrap = el('div', { class: 'bf2-product__img' });
    if (item.image) {
        imgWrap.appendChild(
            el('img', {
                src: item.image,
                alt: item.title || '',
                loading: 'lazy',
                decoding: 'async'
            })
        );
    }
    link.appendChild(imgWrap);

    if (item.title) link.appendChild(el('p', { class: 'bf2-product__title' }, item.title));
    if (item.vendor) link.appendChild(el('p', { class: 'bf2-caps bf2-product__brand' }, item.vendor));
    if (item.price) {
        const price = el('p', { class: 'bf2-product__price' });
        price.innerHTML = item.price;
        link.appendChild(price);
    }

    return link;
}

function render(section, list, currentHandle) {
    const grid = section.querySelector('[data-bf2-recently-grid]');
    if (!grid) return;

    const items = list.filter((item) => item && item.handle && item.handle !== currentHandle);
    if (items.length < 1) {
        section.hidden = true;
        return;
    }

    grid.textContent = '';
    for (const item of items) grid.appendChild(card(item));
    section.hidden = false;
}

function init() {
    const section = document.querySelector('[data-bf2-recently]');
    if (!section) return;

    let current = null;
    const dataTag = section.querySelector('[data-bf2-recently-current]');
    if (dataTag) {
        try {
            current = JSON.parse(dataTag.textContent);
        } catch (e) {
            debug.warn('kunde inte läsa aktuell produkt', e);
        }
    }

    const list = current ? record(current) : readList();
    render(section, list, current ? current.handle : null);
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
